var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","max-width":"300px"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({staticClass:"small",class:_vm.leftSpace ? 'ml-2' : ''},'span',attrs,false),on),[_c('i',{class:_vm.icon})])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }